'use strict';

var index = require('../define-properties/index.js');
var polyfill = require('./polyfill.js');

var define = index;
var getPolyfill = polyfill;

var shim = function shimFlat() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ flat: polyfill },
		{ flat: function () { return Array.prototype.flat !== polyfill; } }
	);
	return polyfill;
};

module.exports = shim;
